import {Component, Input, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {UpdateNavigateTimeAction, VideoNavigateAction} from '../../../shared/stores/root-store/actions/video.action';
import {selectActualVideoState, selectAllTimesFromState} from '../../../shared/stores/root-store/selectors/video.selector';
import {VideoStateEnum} from '../../../../enums/video-state.enum';
import VideoState from '../../../shared/stores/root-store/video.state';

@Component({
    selector: 'eocm-bar',
    templateUrl: './bar.component.html',
    styleUrls: ['./bar.component.scss']
})
export class BarComponent implements OnInit {

    @Input() showBar = true;

    width = 0;
    totalTime = 0;
    navigateToTime = 0;
    videoState: VideoStateEnum;
    blockType = VideoStateEnum.Interaction;
    isCircleThumbVisible = false;

    constructor(private store: Store<{ video: VideoState }>) {
    }

    ngOnInit() {
        this.store.select(selectAllTimesFromState).subscribe(({currentTime, totalTime, navigateToTime}) => {
            this.totalTime = totalTime;
            this.navigateToTime = navigateToTime;
            this.width = Math.min(100, 100 * currentTime / totalTime);
        });
        this.store.select(selectActualVideoState).subscribe((state) =>
            this.videoState = state);
    }

    clickBar(event) {
        if (this.videoState !== this.blockType) {
            this.width = event.offsetX / event.target.offsetWidth * 100;
            const newTime = this.totalTime * (this.width / 100);

            this.store.dispatch(VideoNavigateAction({
                navigationTime: newTime, videoState: this.videoState
            }));
        }
    }

    changeCircleThumbVisibility(visibility: boolean) {
        this.isCircleThumbVisible = visibility;
    }

}
